import { render, staticRenderFns } from "./DeadlyNote.vue?vue&type=template&id=f8219f08&scoped=true"
import script from "./DeadlyNote.vue?vue&type=script&lang=js"
export * from "./DeadlyNote.vue?vue&type=script&lang=js"
import style0 from "./DeadlyNote.vue?vue&type=style&index=0&id=f8219f08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8219f08",
  null
  
)

export default component.exports